module.exports = __webpack_public_path__ + "img/1-1.a3b41396.png";